/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontProductGrid_products = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly categoryPath: string | null;
            readonly categoryCode: string | null;
            readonly ecommerceTrackingParams: unknown | null;
            readonly " $fragmentRefs": FragmentRefs<"StorefrontProductTile_product">;
        } | null;
    } | null> | null;
    readonly " $refType": "StorefrontProductGrid_products";
};
export type StorefrontProductGrid_products$data = StorefrontProductGrid_products;
export type StorefrontProductGrid_products$key = {
    readonly " $data"?: StorefrontProductGrid_products$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductGrid_products">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontProductGrid_products",
  "type": "DealerStorefrontQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryCode",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "ecommerceTrackingParams",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "StorefrontProductTile_product",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '7f0a0a6d19b0517fc1d43c36783d7e8e';
export default node;
